const capitalizeFirstLetter = (strText) => {
  if (typeof strText !== 'string' || !strText) {
    return ''; // Return an empty string for invalid or falsy values
  }
  return strText.charAt(0).toUpperCase() + strText.slice(1);
};

export default capitalizeFirstLetter;
